export const MARKDOWN_FEATURES = {
  BOLD: 'bold',
  ITALIC: 'italic',
  BULLET_LIST: 'bulletList',
  ORDERED_LIST: 'orderedList',
  HARD_BREAK: 'hardBreak'
};

export const MARKDOWN_ALL_FEATURES = Object.values(MARKDOWN_FEATURES);

export function toMarkdownString(value) {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return String(value);
}
